import dotWave from '../elements/dotWave.js';
dotWave.register();
